import { HandAccesibility } from "./hand-accesibility";

export class AssignOrderNoTab {

  static setTabsIndexNonFocus(): void {

    this.setNonFocusFromLabel('a');
    //this.setNonFocusFromLabel('button');
    this.setNonFocusFromLabel('em');
    this.setNonFocusFromLabel('input');
    this.setNonFocusFromLabel('select');
    this.setNonFocusFromLabel('textarea');
    this.setNonFocusFromLabel('link');
    this.setNonFocusFromLabel('img');
    this.setNonFocusFromLabel('img');

  }

  static setNonFocusFromLabel(label: string): void {
    let i:number;
    let objDomAccesibility = document.querySelectorAll(label);
    let objDomExclude = HandAccesibility.DomObjectExclude;

      for (i = 0; i < objDomAccesibility.length; i++) {
        let exclud = objDomExclude.find(a=>a.object == objDomAccesibility[i].id.toString());
        let objDom = objDomAccesibility[i];
        if (!exclud) {
          if (objDom!=null) objDom.setAttribute("tabindex","-1");
        }else{
          if (objDom!=null) objDom.setAttribute("tabindex","0");
        }
      }
    }
}

